module.exports = require("jsonwebtoken");


/*****************
 ** WEBPACK FOOTER
 ** external "jsonwebtoken"
 ** module id = 4
 ** module chunks = 0
 **/